import React from 'react';
import { EditorContent } from '@tiptap/react';

import { SearchHighlightObserver } from '../../../../common/tiptap/extensions/SearchHighlighter';
import { TABLE_CELL_EDITOR_KEY } from '../../../../common/table/tableConstants';
import { TiptapContent } from '../../../../common/tiptap/tiptapTypes';
import useClientElementTiptapEditor from '../../../components/tiptapEditor/useClientElementTiptapEditor';

import { useTableCellRendererTiptapExtensions } from './useTableCellTiptapExtensions';
import { getSpecificEditorId } from '../../utils/elementEditorUtils';

const TABLE_CELL_RENDERER_KEY = `${TABLE_CELL_EDITOR_KEY}-RENDERER`;

type Props = {
    elementId: string;
    textContent: TiptapContent;
    style: React.CSSProperties;
};

const TiptapCellRenderer: React.FC<Props> = ({ elementId, textContent, style }) => {
    const extensions = useTableCellRendererTiptapExtensions();

    const { editor } = useClientElementTiptapEditor({
        persistedContent: textContent,
        extensions,

        editorId: getSpecificEditorId(elementId, TABLE_CELL_RENDERER_KEY),
        editorKey: TABLE_CELL_RENDERER_KEY,

        isEditable: false,
        isEditing: false,
        isSingleSelected: false,
    });

    return (
        <div className="TableTiptapCellRenderer handsontable-renderer" style={style}>
            <SearchHighlightObserver editor={editor} />
            <EditorContent className="TableTiptapCellRenderer-content" dir="auto" editor={editor} />
        </div>
    );
};

export default TiptapCellRenderer;
